<template>
  <div class="nt-theme-articles-bg">
    <div class="ct-large ct-large-carousel">
      <div v-show="isMobile" class="row nt-theme-articles-container nt-theme-articles">
        <div class="swiper-wrapper">
          <slot name="theme-articles"></slot>
        </div>
      </div>
      <div v-show="!isMobile">
          <slot name="theme-articles"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'

export default {
  name: 'nt-theme-articles',
  data() {
    return {
      swiper: null,
      width: 0
    }
  },
  computed: {
    isMobile() {
      return this.width <= 766
    }
  },
  mounted() {
    this.swiper = new Swiper('.nt-theme-articles-container', {
      slidesPerView: 'auto',
      spaceBetween: 50,
      centeredSlides: true
    })

    window.addEventListener('resize', this.onResize)
    this.onResize()
  },
  methods: {
    onResize() {
      this.swiper.virtual.update()
      this.width = window.innerWidth
    }
  }
}
</script>
